document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('[data-demand-form]');

  forms.forEach((form) => {
    const root = form.closest('.custom-restock-demand');
    if (!root) return;

    const productId = form.querySelector('input[name="product_id"]')?.value;
    if (!productId) return;

    const productDataEl = document.getElementById(`DemandProductData-${productId}`);
    if (!productDataEl) return;

    let variants = [];
    try {
      variants = JSON.parse(productDataEl.textContent);
    } catch (error) {
      console.error('Could not parse product variants JSON.', error);
      return;
    }

    const phoneInput = form.querySelector('input[name="phone"]');
    const variantIdInput = form.querySelector('input[name="variant_id"]');
    const variantTitleInput = form.querySelector('input[name="variant_title"]');
    const sizeValueInput = form.querySelector('input[name="size_value"]');
    const colorValueInput = form.querySelector('input[name="color_value"]');
    const skuInput = form.querySelector('input[name="sku"]');
    const selectedColorContextInput = form.querySelector('input[name="selected_color_context"]');
    const selectedVariantContextInput = form.querySelector('input[name="selected_variant_context"]');

    const submitBtn = form.querySelector('[data-demand-submit]');
    const submitBtnText = form.querySelector('.demand-form__submit-text');
    const fieldsWrap = form.querySelector('[data-demand-fields]');
    const errorBox = form.querySelector('[data-demand-error]');
    const errorText = form.querySelector('[data-demand-error-text]');
    const successBox = form.querySelector('[data-demand-success]');
    const currentVariantLabel = root.querySelector('[data-demand-current-variant]');

    const WEBHOOK_URL ='https://coddi-oos-webhook.mohannad-ashraf7.workers.dev/';

    function getProductForm() {
      const popup = form.closest('.product-modal');
      if (popup) {
        const productSection = popup.closest('.shopify-section');
        if (productSection) {
          const scopedForm = productSection.querySelector('form[action*="/cart/add"]');
          if (scopedForm) return scopedForm;
        }
      }
      return document.querySelector('form[action*="/cart/add"]');
    }

    function getCurrentSelectedVariantId() {
      const productForm = getProductForm();
      const variantInput = productForm?.querySelector('input[name="id"]');
      return variantInput?.value || selectedVariantContextInput?.value || null;
    }

    function getCurrentSelectedVariant() {
      const currentId = getCurrentSelectedVariantId();
      if (!currentId) return null;
      return variants.find((variant) => String(variant.id) === String(currentId)) || null;
    }

    function syncVariantFields() {
      const variant = getCurrentSelectedVariant();
      if (!variant) return false;

      variantIdInput.value = variant.id || '';
      variantTitleInput.value = variant.title || '';
      sizeValueInput.value = variant.option1 || '';
      colorValueInput.value = variant.option2 || '';
      skuInput.value = variant.sku || '';
      selectedColorContextInput.value = variant.option2 || '';
      selectedVariantContextInput.value = variant.id || '';

      if (currentVariantLabel) {
        currentVariantLabel.textContent = variant.title || '';
      }

      return true;
    }

    function showError(message) {
      if (!errorBox || !errorText) return;
      errorText.textContent = message;
      errorBox.hidden = false;
    }

    function hideError() {
      if (errorBox) errorBox.hidden = true;
    }

    function showSuccess() {
      if (fieldsWrap) fieldsWrap.hidden = true;
      if (successBox) successBox.hidden = false;
      hideError();
    }

    function resetSuccess() {
      if (fieldsWrap) fieldsWrap.hidden = false;
      if (successBox) successBox.hidden = true;
    }

    function setLoadingState(isLoading) {
      if (!submitBtn || !submitBtnText) return;

      submitBtn.disabled = isLoading;
      submitBtn.classList.toggle('is-loading', isLoading);

      if (isLoading) {
        submitBtnText.textContent = 'Saving...';
      } else {
        submitBtnText.textContent = 'Save my request';
      }
    }

    function validatePhone(value) {
      const cleaned = value.replace(/[^\d+]/g, '');
      return cleaned.length >= 8;
    }

    function focusPhoneOnOpen() {
      setTimeout(() => {
        if (phoneInput && !successBox?.hidden) return;
        if (phoneInput && fieldsWrap && !fieldsWrap.hidden) {
          phoneInput.focus();
        }
      }, 120);
    }

    document.addEventListener('click', (event) => {
      const openBtn = event.target.closest('[data-popup-open]');
      if (!openBtn) return;

      setTimeout(() => {
        syncVariantFields();
        resetSuccess();
        hideError();
        focusPhoneOnOpen();
      }, 80);
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!target) return;

      const productForm = getProductForm();
      if (!productForm) return;
      if (!productForm.contains(target)) return;

      setTimeout(() => {
        syncVariantFields();
      }, 50);
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      hideError();
      resetSuccess();

      const hasVariant = syncVariantFields();

      const phone = phoneInput?.value?.trim() || '';

      if (!phone) {
        showError('Please enter your phone number.');
        phoneInput?.focus();
        return;
      }

      if (!validatePhone(phone)) {
        showError('Please enter a valid phone number.');
        phoneInput?.focus();
        return;
      }

      if (!hasVariant || !variantIdInput.value) {
        showError('Could not detect the selected size. Please close this popup, choose the size again, and retry.');
        return;
      }

      const payload = {
        phone,
        product_name: form.querySelector('input[name="product_name"]').value,
        product_id: form.querySelector('input[name="product_id"]').value,
        variant_id: variantIdInput.value,
        variant_title: variantTitleInput.value,
        size: sizeValueInput.value,
        color: colorValueInput.value,
        sku: skuInput.value,
        product_url: form.querySelector('input[name="product_url"]').value,
        handle: form.querySelector('input[name="handle"]').value,
        selected_color_context: selectedColorContextInput.value,
        selected_variant_context: selectedVariantContextInput.value,
        submitted_at: new Date().toISOString()
      };

      try {
        setLoadingState(true);

        const response = await fetch(WEBHOOK_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        form.reset();
        syncVariantFields();
        showSuccess();
      } catch (error) {
        console.error('Demand form submission failed:', error);
        showError('Something went wrong while saving your request. Please try again.');
      } finally {
        setLoadingState(false);
      }
    });

    syncVariantFields();
  });
});